import { Injectable } from '@angular/core';
import { ArlDataFromFile } from '@dave/types';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { FileOpenerOpenRequestActions } from '../State/actions/file-opener-open-request.actions';
import { AppGatewayService } from './app-gateway.service';
import { MaterialPricesBySupplier } from '@dave/types/dist/proto/erp/materialToSupplier';
import { GaebPositionType } from '@dave/types/dist/proto/gabe/gabeCommon';

@Injectable({
    providedIn: 'root',
})
export class InvoicingDataService {
    constructor(private api: AppGatewayService, private store$: Store<State>) {}

    async getInvoiceDataFromFile(versionId: number, flat: boolean, withoutTextPositions: boolean, ledgerImportId?: number): Promise<ArlDataFromFile[] | null> {
        try {
            let res = await this.api
                .Request({
                    GabeGetArlDataFromFile: {
                        VersionId: versionId.toString(),
                        LedgerImportId: ledgerImportId ? ledgerImportId.toString() : null,
                    },
                });
            if (Object.keys(res?.Errors || {}).length === 0) {
                if (res.GabeGetArlDataFromFile?.ArlDataFromFile) {
                    if (withoutTextPositions) {
                        res.GabeGetArlDataFromFile.ArlDataFromFile =  res.GabeGetArlDataFromFile.ArlDataFromFile.filter(x => x.Type !== GaebPositionType.Text);
                    }

                    if (flat) {

                        return res.GabeGetArlDataFromFile.ArlDataFromFile.map(flatArlDataFromFile).flat();



                        // const flatData: ArlDataFromFile[] = [];
                        // let children = res.GabeGetArlDataFromFile.ArlDataFromFile;
                        // while (children.length > 0) {
                        //     flatData.push(...children.map(c => ({...c, Children: null})));
                        //     children = children.flatMap(c => c.Children || []);
                        // }
                        // return flatData;
                    }

                    return res.GabeGetArlDataFromFile.ArlDataFromFile;
                } else {
                    throw new Error('wrong Response GabeGetArlDataFromFile');
                }
            } else {
                throw res.Errors;
            }
        } catch (err) {
            this.store$.dispatch(
                FileOpenerOpenRequestActions.loadFailure({
                    Payload: {
                        ToasterMessage: 'Rechnungsdatei einlesen fehlgeschlagen',
                        Errors: err,
                    },
                }),
            );
            return null;
        }
    }
    async getMaterialToSupplierPrices(materialIds: number[], supplierIds: number[]): Promise<MaterialPricesBySupplier[] | null> {
        try {
            let res = await this.api
                .Request({
                    ErpMaterialToSupplierPrices: {
                        MaterialIds: materialIds.map(id => id.toString()),
                        SupplierIds: supplierIds.map(id => id.toString()),
                    },
                });
            if (Object.keys(res?.Errors || {}).length === 0) {
                if (res.ErpMaterialToSupplierPrices?.Materials) {
                    return res.ErpMaterialToSupplierPrices.Materials;
                } else {
                    throw new Error('wrong Response ErpMaterialToSupplierPrices');
                }
            } else {
                throw res.Errors;
            }
        } catch (err) {
            this.store$.dispatch(
                FileOpenerOpenRequestActions.loadFailure({
                    Payload: {
                        ToasterMessage: 'Materialpreise abrufen fehlgeschlagen',
                        Errors: err,
                    },
                }),
            );
            return null;
        }
    }
}

function flatArlDataFromFile(arl: ArlDataFromFile): ArlDataFromFile[] {
    return [{...arl, Children: null}, ...(arl.Children || []).map(flatArlDataFromFile).flat()]
}
